import { useEffect, useState } from 'react';
import { migrateLegacyQueues } from '../utils/firebase/migrateTransactions';

/**
 * Resolves after ebay, whatnot, and sales have been copied into transactions.
 * Queue listeners must wait, or they would miss rows still in the old collections.
 */
export default function useTransactionsReady(uid) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!uid) {
      setReady(false);
      return undefined;
    }

    let cancelled = false;
    setReady(false);
    migrateLegacyQueues(uid)
      .catch((error) => {
        console.error('Failed to migrate transactions', error);
      })
      .finally(() => {
        if (!cancelled) setReady(true);
      });

    return () => {
      cancelled = true;
    };
  }, [uid]);

  return ready;
}
